import { ComponentPropsWithoutRef } from "react";

import { arrowLineLeftCss } from "./WordStudyOrganizer.styles";

const ArrowLineLeft = (props: ComponentPropsWithoutRef<"div">) => (
  <div role="img" aria-hidden="true" {...props} css={arrowLineLeftCss} />
);

export default ArrowLineLeft;
